import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled from '@emotion/styled';
import { inputPlaceholder } from '../../shared/styles';
var Hidden = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  visibility: hidden;\n  opacity: 0;\n  display: inline-block;\n"], ["\n  visibility: hidden;\n  opacity: 0;\n  display: inline-block;\n"])));
export var Mask = styled(function (_a) {
    var value = _a.value, mask = _a.mask, className = _a.className;
    var isFilled = value.length === mask.length;
    // in order to set the minimum width for the input field
    // https://jira.metrosystems.net/browse/MUI-960
    var placeholderMinWidth = 0.6 * value.length;
    return (React.createElement("span", { className: className, "aria-hidden": true },
        React.createElement(Hidden, { style: { minWidth: placeholderMinWidth + "rem" } }, isFilled ? value : mask.substring(0, value.length)),
        mask.substring(value.length)));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  pointer-events: none;\n"], ["\n  ", "\n\n  pointer-events: none;\n"])), inputPlaceholder);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Mask.js.map